import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
export type MarketingInfoFragment = { salesCount: number, positiveFeedbackCount: number };

export const MarketingInfoFragmentDoc = gql`
    fragment MarketingInfoFragment on MarketingInfoType {
  salesCount
  positiveFeedbackCount
}
    `;